// extracted by mini-css-extract-plugin
export default {"NewTagDialog":"NewTagDialog_NewTagDialog__N88QR"};